import { 
  SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE,
  SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS,
  SET_ADMIN_AUDIT_TOURNAMENT_HEADER, 
  SET_ADMIN_AUDIT_TOURNAMENT_DETAILS
} from './constants';

export const setSearchTournamentValue = (searchValue) => ({
  type: SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE,
  payload: searchValue
});

export const displayTournamentAudit = (searchValue) => ({
  type: SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS,
  payload: searchValue
});

export const displayTournamentAuditHeader = (data) => ({
  type: SET_ADMIN_AUDIT_TOURNAMENT_HEADER, 
  payload: data
});

export const displayTournamentAuditDetails = (data) => ({
  type: SET_ADMIN_AUDIT_TOURNAMENT_DETAILS,
  payload: data
});



// WEBPACK FOOTER //
// ./src/features/admin/audit/tournamentAudit/actionTypes.js